import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import IdleVue from 'idle-vue'
import logger from './utils/logger'


const eventsHub = new Vue()

Vue.use(Vuelidate)
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 900000
})

Vue.config.productionTip = false

// Catch component-level errors that would otherwise be swallowed, so they leave
// a trace in the console (and, later, an external tracker via the logger).
Vue.config.errorHandler = (err, vm, info) => {
  logger.error('Vue', err, `(hook: ${info})`)
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
